import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=6b6f9d6a&scoped=true&"
import script from "./InfoSection.vue?vue&type=script&lang=ts&"
export * from "./InfoSection.vue?vue&type=script&lang=ts&"
import style0 from "./InfoSection.vue?vue&type=style&index=0&id=6b6f9d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f9d6a",
  null
  
)

export default component.exports